export default "__VITE_ASSET__DbVWkZLb__"